export type IShowFormGroupWarning = (element: IjQueryElmOrHtmlElm, message?: string) => void;

export function showFormGroupWarning(element: IjQueryElmOrHtmlElm, message = ''): void {
  const $formGroup = $(element).closest('.form-group');
  const $errorBlock = $formGroup.find('.error-block');
  $formGroup.removeClass('has-error has-success').addClass('has-warning');
  $errorBlock
    .removeClass('hide')
    .attr('aria-hidden', 'false')
    .text(message);
}
